import Vue from 'vue';
import store from './../../store';
import purchaseStatusTransformer from './../../transformers/purchaseStatus';

const success = ({ data }, resolve) => {
  const purchaseStatuses = purchaseStatusTransformer.fetchCollection(data.data);

  store.dispatch('fetchPurchaseStatuses', purchaseStatuses);
  resolve();
};

const failed = () => {
};

// Display purchase statuses.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('purchase_status')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/purchaseStatus/all.js